import { useEffect, useRef } from "react";
import { Box } from "@mui/material";

export default function HeroClip({ onVisibilityChange }) {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  // Navbar light/dark detection
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => onVisibilityChange?.(entry.isIntersecting),
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [onVisibilityChange]);

  // Ensure playback always resumes
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const play = () => video.play().catch(() => {});
    play();

    document.addEventListener("visibilitychange", play);
    return () => document.removeEventListener("visibilitychange", play);
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        width: "100%",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      <video
        ref={videoRef}
        src="/videos/hero.mp4"
        muted
        autoPlay
        loop
        playsInline
        preload="auto"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center top",
        }}
      />
    </Box>
  );
}
